
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import StateButton from '@/components/inputs/StateButton.vue';

import userx from '@/store/modules/userx';
import programx from '@/store/modules/programx';
import programz from '@/store/programz';
import progressToastx from '@/store/modules/progressToastx';

import {
	SoftwareType,
	ProgramData,
	ExtractorItem,
	EditState,
	UpdateProgramSubmission,
	fileFormats,
	FileFormat,
} from '@/store/models.def';
import ProgramGroup from './ProgramGroup.vue';
import DeleteProgramModal from './DeleteProgramModal.vue';
import uuid from 'uuid';

@Component({
	components: {
		ProgramGroup,
		StateButton,
		DeleteProgramModal,
	},
})
export default class ProgramProfile extends Vue {
	public get groups() {
		return (this.data)
			? this.data.groups.map((group) => ({
					group,
			  }))
			: [];
	}

	public get id() {
		return this.data && this.data.id;
	}
	public get softwareType() {
		return this.data && this.data.softwareType;
	}

	public get supportLvl() {
		return userx.user && userx.user.supportLvl;
	}

	public get fileFormatOptions() {
		return fileFormats.map((f) => ({ value: f, text: f }));
	}

	public get updateProgramLabel() {
		const labels = {
			active: 'Update Program',
			sending: 'Updating...',
			done: 'Updated Program',
		};
		return labels[this.updateProgramState];
	}
	@Prop({ default: null }) public value!: ProgramData | null;

	public updateProgramState: EditState = 'active';

	public data: ProgramData | null = null;

	@Watch('value')
	public onValueChanged(val: ProgramData, oldVal: ProgramData) {
		if (val !== null) {
			val.fileFormat = val.fileFormat || 'both';
			this.data = val;

			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public mounted() {
		let result = null;
		if (this.value) {
			this.value.fileFormat = this.value.fileFormat || 'both';
			this.data = this.value;
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}
	public addGroup() {
		this.data!.groups = [
			...this.data!.groups,
			{
				group: '',
				queries: [],
			},
		];
		this._onInput();
	}
	public removeGroup(index: number) {
		this.data!.groups.splice(index, 1);
		this._onInput();
	}
	public async updateProgram() {
		if (this.updateProgramState !== 'active') {
			return;
		}
		if (!this.value) {
			return;
		}
		const toastId = await progressToastx.add({
			title: `${this.id}`,
			state: `Updating program...`,
			variant: 'info',
		});
		this.updateProgramState = 'sending';
		const submission: UpdateProgramSubmission = {
			id: this.value.id,
			groups: this.value.groups,
			fileFormat: this.value.fileFormat || 'both',
		};
		let result: any = await programx.updateProgram(submission);
		// Handle case where result comes back as array
		if (Array.isArray(result)) { result = result[0]; }
		this.updateProgramState = 'active';
		if (result && result.success) {
			progressToastx.done({ id: toastId, state: `Program updated!` });
		} else {
			progressToastx.error({ id: toastId, state: result && result.errorMessage });
		}
	}
	public openDeleteModal() {
		if (!this.data) { return; }
		const modal = this.$refs.deleteProgramModal as DeleteProgramModal;
		if (modal) {
			modal.show(this.data);
		}
	}

	public onProgramDeleted(deletedProgramId: string) {
		// Select another program after deletion
		const remainingPrograms = programx.allPrograms.filter((p) => p.id !== deletedProgramId);
		if (remainingPrograms.length > 0) {
			// Select the first remaining program (deep clone to avoid mutation issues)
			this.$emit('input', JSON.parse(JSON.stringify(remainingPrograms[0])));
		} else {
			this.$emit('input', null);
		}
	}

	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		for (const group of this.groups) {
			if (!group.group) {
				return null;
			}
		}
		return this.data;
	}
}
